// ===============================
// Login Steps
export const loginInitialStep = {
  notifications: {
    successVerification: 'Your email address was successfully verified!',
    errorVerification: 'Sorry, we can not identify your email address!',
    errorWrongCredentials: 'Sorry, wrong credentials — try again!',
  },
  hello: 'Get Started',
  title: 'Welcome to FriendlyScore',
  subTitle: 'Please log in to the platform.',
};

export const loginSmsCodeStep = {
  hello: 'Phone verification',
  title: 'Enter your verification code',
  subTitle: 'Input the code we sent to',
};

// ===============================
// Register Steps
export const registerInitialStep = {
  hello: 'Get Started',
  title: 'Welcome to FriendlyScore',
  subTitle: 'Let’s start with your professional e-mail.',
};

export const registerAccountSetupStep = {
  hello: 'Get Started',
  title: 'Set up your account',
  subTitle: 'Fill in the details below.',
};

export const registerPhoneNumberStep = {
  hello: 'Get Started',
  title: 'Verify your phone number',
  subTitle:
    'To make sure it’s really you, FriendlyScore will send you a text with a 4 digit verification code.',
};

export const registerSmsCodeStep = {
  hello: 'Phone verification',
  title: 'Enter your verification code',
  subTitle: 'Input the code we sent to',
};

export const registerEmploymentBasicStep = {
  hello: 'Get Started',
  title: 'Let’s create the best experience for you.',
  subTitle:
    'Tell us more about you and your company to provide you more personalise service.',
  showTransactionDetailsPrefix: `We`,
  showTransactionDetailsSuffix: 'bank transaction information to customers.',
};

export const registerEmploymentDetailsStep = {
  hello: 'Get Started',
  title: 'Let’s create the best experience for you.',
  subTitle:
    'Tell us more about you and your company to provide you more personalise service.',
  industryPrefix: 'My company works in the',
  industrySuffix: 'industry,',
  positionPrefix: `and I work day to day in the`,
  positionSuffix: 'department.',
  numberOfEmployeesPrefix: 'My company employs',
  numberOfEmployeesSuffix: 'people.',
  numberOfCustomersPrefix: `We serve`,
  numberOfCustomersSuffix: 'customers per month.',
  showTransactionDetailsPrefix: `We`,
  showTransactionDetailsSuffix: 'bank transaction information to customers.',
};

export const registerLastStepStep = {
  hello: 'Get Started',
  title: 'Yay! We’re almost there...',
  subTitle: 'Invite your teammates and build your workflows together.',
  caption: 'Invite with email',
};

export const registerSuccessStep = {
  title: 'Success! Check your email.',
  description:
    'We have sent you a verification email to confirm your address. Please go to your mailbox and follow the instructions.',
};

// ===============================
// Reset Password Steps
export const resetPasswordInitialStep = {
  hello: 'Reset',
  title: 'Need to reset your password?',
  subTitle: `Enter your email address and we'll send you a link.`,
};

export const resetPasswordSuccessStep = {
  title: 'Check your email!',
  description:
    'If your email is on file then you should be receiving a verification email to reset your password.',
};

export const resetPasswordSetNewStep = {
  hello: 'New Password',
  title: 'Reset account password',
  subTitle: 'Enter your new password below.',
};

export const resetPasswordSetNewSuccessStep = {
  title: 'Your new password is set!',
  description: 'You can now login to your account.',
  buttonLabel: 'Go to login page',
};

// ===============================
// Register from Invitation

export const registerFromInvitationErrorStep = {
  title: 'Sorry, something went wrong!',
  description:
    'This link has expired. Please request a new one from your administrator.',
  buttonLabel: 'Go back to Login',
};

export const registerFromInvitationInitialStep = {
  hello: 'Hi!',
  title: 'Setup your account',
  subTitle: 'Fill in the details below to finish your account registration.',
};

export const registerFromInvitationSmsCodeStep = {
  hello: 'Phone verification!',
  title: 'Enter your verification code',
  subTitle: 'Input the code we sent to',
};

export const registerFromInvitationSuccessStep = {
  title: 'Your account is setup!',
  description: 'You can now login to your account.',
  buttonLabel: 'Go to Login page',
};

// ===============================
// Reusable Steps

export const smsCodeStep = {
  notifications: {
    sendAgain: 'The verification code is send.',
    successSmsCode: 'The verification code is correct!',
    errorSmsCode: 'The verification code is incorrect.',
  },
  wrongSmsCodeErrorLabel:
    'The verification code is incorrect. Please try again.',
};
